import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-request-spinner',
  templateUrl: './request-spinner.component.html',
  styleUrls: ['./request-spinner.component.scss']
})
export class RequestSpinnerComponent implements OnInit {

  @Input() isRequestActive;

  constructor() { }

  ngOnInit() {
  }

}
